import React, { useEffect, useRef, useState } from 'react'
import Grid from '../Shared_Grid'
import { Button, Stack, TextField, Typography } from '@mui/material'
import httpClient from '../../_util/api'
import { useParams } from 'react-router-dom'
import uploadCloudIcon from '../../assets/images/uploadCloudIcon.png'
import { hideLoader, setAddNotePopupOpen, showLoader } from '../../Store/mainSlice'
import { useDispatch, useSelector } from 'react-redux'
import CustomizedSnackbars from '../Snackbar/SnackBar'
import { File, Images, Paperclip } from '@phosphor-icons/react'
import AddNotePopup from '../AddNotePopup'

const StudentDetail = (props) => {
    const { id } = useParams()
    const { stdId } = useParams()
    const { CNICNo } = useParams()
    const snackbar_Ref = useRef()
    const dispatch = useDispatch()
    const isAddNotePopupOpen = useSelector((state) => state.mainSlice.addNotePopupOpen)
    const role = localStorage.getItem('role')
    const [gridData, setGridData] = useState([])
    const [attachments, setAttachments] = useState([])
    const [financialDocs, setFinancialDocs] = useState([])
    const createdBy = localStorage.getItem("firstName")
    const [notesData, setNotesData] = useState([
        {
            name: "",
            createdBy: createdBy,
            description: ""
        }
    ])


    const gridHeader = [
        {
            field: "firstName",
            headerName: "Name"
        },
        {
            field: "totalAmount",
            headerName: "Amount"
        },
        {
            field: "applicationSubmitDate",
            headerName: "Application Submission Date"
        },
        {
            field: role == "al-kauser Admin" ? "alKauserReviewStatus" : role == "vendor" ? "vendorReviewStatus" : "status",
            headerName: "Status"
        },
        {
            field: "view",
            isButton: true
        },
        role === 'vendor' &&
        {
            field: "upload",
            isButton: true,
        }
    ]

    const financialHeader = [
        {
            field: "firstName",
            headerName: "Name"
        },
        {
            field: "date",
            headerName: "Date"
        },
        {
            field: "view",
            isButton: true
        }
    ]

    const notesHeader = [
        // {
        //     field: "firstName",
        //     headerName: "Name"
        // },
        {
            field: "createdBy",
            headerName: "Created By"
        },
        {
            field: "noteCreationDate",
            headerName: "Date"
        },
        {
            field: "view/edit",
            isButton: true
        }
    ]

    const getStudentDetail = async () => {
        const res = await httpClient.get(`/students/getStudentById/${stdId}`).catch((error) => {
            console.log("error", error.message);
        })

        if (res?.status === 200) {
            console.log("res", res.data)
            setGridData(res.data)
        }
    }

    const getAllApplicationByCNICNo = async () => {
        const res = await httpClient.get(`/students/getAllApplicationByCNICNo/${CNICNo}`).catch((error) => {
            console.log("error", error.message);
        })

        if (res?.status === 200) {
            console.log("res", res?.data)
            setGridData(res?.data)
        }
    }

    const getAllAttachmentsByCNICNo = async () => {
        const res = await httpClient.get(`/students/getAllAttachmentsByCNICNo/${CNICNo}`).catch((error) => {
            console.log("error", error.message);
        })

        if (res?.status === 200) {
            const attachmentsData = res.data.attachmentsArray;
            setAttachments(attachmentsData);
        }
    }

    const getAllFinancialDocsByCNICNo = async () => {
        const res = await httpClient.get(`/students/getAllFinancialDocsByCNICNo/${CNICNo}`).catch((error) => {
            console.log("error", error.message);
        })

        if (res?.status === 200) {
            const financialDocsData = res.data.financialDocsArray;
            setFinancialDocs(financialDocsData);
        }
    }

    const notesSubmitHandler = async () => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/createNotes/${stdId}`, notesData).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })

        if (res?.status === 200) {
            dispatch(hideLoader())
        }
    }

    const getAllNotesByCNICNo = async () => {
        dispatch(showLoader())
        const res = await httpClient.get(`/students/getAllNotesByCNICNo/${CNICNo}`).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })

        if (res?.status === 200) {
            dispatch(hideLoader())
            setNotesData(res?.data)
        }
    }

    const labels = {
        resultOfLastExamFile: 'Result/Transcript Of Last Exam',
        feeVoucherFile: 'Fee Voucher',
        CNICFrontFile: 'Student CNIC(Front)',
        CNICBackFile: 'Student CNIC(Back)',
        parentCNICFrontFile: 'Parent CNIC(Front)',
        parentCNICBackFile: 'Parent CNIC(Back)',
        proofOfIncomeFile: 'Proof Of Income',
        currentElectricBillFile: 'Current Electric Bill',
        additionalDocs: 'Matric and Intermediate Marksheet',
        otherDocumentsFile: 'Other Documents',
        referenceLetterFile1: 'Reference Letter 1',
        referenceLetterFile2: 'Reference Letter 2',
    };

    const financialDocsLabel = {
        applicationPic: 'Misc. Applications',
        feeChallanPic: 'Fee Challans',
        invoicePic: 'Invoice',

    }

    function openPDFInNewTab(pdfUrl) {
        // Create a new <a> element
        const link = document.createElement('a');
        // Set the href attribute to the PDF file URL
        link.href = pdfUrl;
        // Set the target attribute to '_blank' to open in a new tab
        link.target = '_blank';
        // Trigger a click event on the link
        link.click();
    }

    const closeAddNotePopup = async () => {
        // setIsAddNOtePopupOpen(true)
        dispatch(setAddNotePopupOpen(false))
        getAllNotesByCNICNo()
    }


    useEffect(() => {
        if (props.value === 0) {
            getAllApplicationByCNICNo()
        }
        else if (props.value === 1) {
            getAllFinancialDocsByCNICNo()
        }
        else if (props.value === 2) {
            // if (role === 'admin') {
            getAllNotesByCNICNo()
            // }
            // else {
            //     getAllAttachmentsByCNICNo()
            // }
        }
        // else if (props.value === 2 && role === 'vendor'){
        //     getAllAttachmentsByCNICNo()
        // }
        else if (props.value === 3) {
            getAllAttachmentsByCNICNo()
        }
    }, [props.value])

    return (
        <>
            {isAddNotePopupOpen && <AddNotePopup open={true} onClose={closeAddNotePopup} stdId={stdId} CNICNo={CNICNo}/>}
            <CustomizedSnackbars ref={snackbar_Ref} />
            {
                props.value === 0 && (
                    <Stack sx={{ width: "98%" }}>
                        {Object.keys(gridData).length > 0 && (
                            <Grid
                                gridHeader={gridHeader}
                                gridData={gridData}
                                id={id}
                                stdId={stdId}
                            />
                        )}
                    </Stack>
                )
            }
            {
                props.value === 1 && (
                    <Stack sx={{ width: '95%', height: '100%', overflowY: 'auto' }}>
                        {
                            financialDocs.map((docs, index) => {
                                return (
                                    <Stack key={index} spacing={2}>
                                        {Object.keys(docs).map((financialDocsKey) => {
                                            if (financialDocsKey == 'grade') {
                                                console.log("financialDocsKey", financialDocsKey)
                                                return <Typography variant='h6' sx={{ fontWeight: 'bold', }}>FINANCIAL DOCS OF { docs[financialDocsKey] } SEMESTER:</Typography>
                                            }

                                            if (financialDocsKey === 'files') {
                                                const files = docs[financialDocsKey];

                                                return Object.keys(files).map((fileKey) => {
                                                    if (fileKey == 'applicationPic') {
                                                        return (
                                                            <Stack key={fileKey} spacing={2}>
                                                                 <Typography sx={{ color: "#208146", fontWeight: 'bold' }}>{financialDocsLabel[fileKey]}:</Typography>
                                                                {files[fileKey].map((doc, docIndex) => (
                                                                    <Stack
                                                                        key={doc._id || docIndex}
                                                                        spacing={1}
                                                                        sx={{ cursor: "pointer" }}
                                                                        onClick={(e) => {
                                                                            if (doc.url) openPDFInNewTab(doc.url);
                                                                            e.stopPropagation();
                                                                        }}
                                                                    >
                                                                        <Stack
                                                                            flexDirection={'row'}
                                                                            alignItems={'center'}
                                                                            sx={{
                                                                                border: '2px solid #208146',
                                                                                width: '50%',
                                                                                height: '54px',
                                                                                borderRadius: '11px',
                                                                            }}
                                                                        >
                                                                            <Stack
                                                                                flexDirection={'row'}
                                                                                alignItems={'center'}
                                                                                justifyContent={'space-around'}
                                                                                sx={{ width: '70%' }}
                                                                            >
                                                                                <Images size={32} weight="thin" color="#208146" />
                                                                                <Typography>
                                                                                    {doc.fileName || 'No file available'}
                                                                                </Typography>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </Stack>
                                                                ))}
                                                            </Stack>
                                                        )
                                                    }
                                                    return (
                                                        <Stack
                                                            key={fileKey}
                                                            spacing={1}
                                                            sx={{ cursor: "pointer" }}
                                                            onClick={(e) => {
                                                                if (files[fileKey].url) openPDFInNewTab(files[fileKey].url);
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Typography sx={{ color: "#208146", fontWeight: 'bold' }}>
                                                                {financialDocsLabel[fileKey]}:
                                                            </Typography>
                                                            {/* <Typography>Attachments Of {{key}} Semester</Typography> */}
                                                            <Stack
                                                                flexDirection={'row'}
                                                                alignItems={'center'}
                                                                sx={{
                                                                    border: '2px solid #208146',
                                                                    width: '50%',
                                                                    height: '54px',
                                                                    borderRadius: '11px',
                                                                }}
                                                            >
                                                                <Stack
                                                                    flexDirection={'row'}
                                                                    alignItems={'center'}
                                                                    justifyContent={'space-around'}
                                                                    sx={{ width: '70%' }}
                                                                >
                                                                    <Images size={32} weight="thin" color="#208146" />
                                                                    <Typography>
                                                                        {files[fileKey].fileName || 'No file available'}
                                                                    </Typography>
                                                                </Stack>
                                                            </Stack>
                                                        </Stack>
                                                    )

                                                });
                                            }
                                        })}
                                    </Stack>
                                )


                            })
                        }
                    </Stack>
                )
            }
            {
                props.value === 2 && (
                    <Stack alignItems={'flex-end'} sx={{ width: '95%', height: '100' }}>
                        <Button
                            variant="contained"
                            sx={{
                                // display: role === 'admin' ? 'block' : "none",
                                display:"block",
                                backgroundColor: "#208146",
                                color: 'white',
                                width: '98px',
                                height: "5vh",
                                fontSize: '12px',
                                borderRadius: '12px',
                                "&:hover": {
                                    backgroundColor: "#208146",
                                },
                            }}
                            onClick={() => dispatch(setAddNotePopupOpen(true))}
                        >
                            Add Note
                        </Button>
                        {Object.keys(gridData).length > 0 && (
                            <Grid
                                gridHeader={notesHeader}
                                gridData={notesData}
                                id={id}
                                stdId={stdId}
                            />
                        )}

                    </Stack>
                )
            }
            {
                props.value === 3 && (
                    <Stack sx={{ width: '95%', height: '100%', overflowY: 'auto' }}>
                        {attachments.map((attachment, index) => (
                            <Stack key={index} spacing={2}>
                                {Object.keys(attachment).map((attachmentKey) => {
                                    if (attachmentKey == 'grade') {
                                        return <Typography variant='h6' sx={{ fontWeight: 'bold' }}>ATTACHMENTS OF {attachment[attachmentKey]} SEMESTER:</Typography>
                                    }


                                    if (attachmentKey === 'files') {
                                        const files = attachment[attachmentKey];

                                        return Object.keys(files).map((fileKey) => {
                                            if (fileKey == 'additionalDocs') {
                                                // console.log("files[fileKey]",files[fileKey]);

                                                return (
                                                    <Stack key={fileKey} spacing={2}>
                                                        <Typography sx={{ color: "#208146", fontWeight: 'bold' }}>{labels[fileKey]}:</Typography>
                                                        {files[fileKey].map((doc, docIndex) => (
                                                            <Stack
                                                                key={doc._id || docIndex}
                                                                spacing={1}
                                                                sx={{ cursor: "pointer" }}
                                                                onClick={(e) => {
                                                                    if (doc.url) openPDFInNewTab(doc.url);
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                <Stack
                                                                    flexDirection={'row'}
                                                                    alignItems={'center'}
                                                                    sx={{
                                                                        border: '2px solid #208146',
                                                                        width: '50%',
                                                                        height: '54px',
                                                                        borderRadius: '11px',
                                                                    }}
                                                                >
                                                                    <Stack
                                                                        flexDirection={'row'}
                                                                        alignItems={'center'}
                                                                        justifyContent={'space-around'}
                                                                        sx={{ width: '70%' }}
                                                                    >
                                                                        <Images size={32} weight="thin" color="#208146" />
                                                                        <Typography>
                                                                            {doc.fileName || 'No file available'}
                                                                        </Typography>
                                                                    </Stack>
                                                                </Stack>
                                                            </Stack>
                                                        ))}
                                                    </Stack>
                                                )
                                            }
                                            return (
                                                <Stack
                                                    key={fileKey}
                                                    spacing={1}
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        if (files[fileKey].url) openPDFInNewTab(files[fileKey].url);
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <Typography sx={{ color: "#208146", fontWeight: 'bold' }}>
                                                        {labels[fileKey]}:
                                                    </Typography>
                                                    {/* <Typography>Attachments Of {{key}} Semester</Typography> */}
                                                    <Stack
                                                        flexDirection={'row'}
                                                        alignItems={'center'}
                                                        sx={{
                                                            border: '2px solid #208146',
                                                            width: '50%',
                                                            height: '54px',
                                                            borderRadius: '11px',
                                                        }}
                                                    >
                                                        <Stack
                                                            flexDirection={'row'}
                                                            alignItems={'center'}
                                                            justifyContent={'space-around'}
                                                            sx={{ width: '70%' }}
                                                        >
                                                            <Images size={32} weight="thin" color="#208146" />
                                                            <Typography>
                                                                {files[fileKey].fileName || 'No file available'}
                                                            </Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            )

                                        });
                                    }
                                })}
                            </Stack>
                        ))}
                    </Stack>
                )
            }
        </>
    )
}

export default StudentDetail